// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsCreateInvoice/mutation-create-invoice.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_EmbeddableCoreMessageListener_PaymentsCreateInvoice($invoice: jsonb, $current_location_id: numeric!) {
  payments_create_invoice(
    args: { invoice: $invoice, current_location_id: $current_location_id }
  ) {
    id
  }
}

`